import { ActionTypes } from '../actions';

export const INITIAL_STATE = {
  usersRecip: {},
  usersNoRecip: {},
  requests: 0,
};

const MatchReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.UPDATE_MATCHES:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.CLEAR_MATCHES:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default MatchReducer;
